import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const HeadingEpsilon = (props) => (
  <h5 className={classNames({
    'epsilon': true,
    [props.className]: props.className,
    'centered': props.center,
    'thin': props.thin
  })}>
    { props.children }
  </h5>
)

HeadingEpsilon.propTypes = {
  center: PropTypes.bool,
  thin: PropTypes.bool
}

export default HeadingEpsilon


// WEBPACK FOOTER //
// ./src/ui/headings/heading-epsilon.js